import { PartnerType } from "@/app/utils/partners.enum";
import { httpClient } from "../http/httpClient";

export enum AuthorizationStatusEnum {
  PENDING = "PENDING",
  AUTHORIZED = "AUTHORIZED",
  NO_OFFER = "NO_OFFER",

  COMPLETED = "COMPLETED",
}

export type GetAuthorizationParams = {
  cpf?: string;
  sellerIds?: string[];
  customerIds?: string[];
  status?: AuthorizationStatusEnum[];
  search?: string;
  type?: PartnerType[];
  skip?: number;
  limit?: number;
  sort?: string;
  order?: "1" | "-1";
};

export type PreTransaction = {
  _id: string;
  sellerId: {
    _id: string;
    name: string;
    profileImageUrl?: string;
  };
  customerId: {
    _id: string;
    name: string;
    cpf: string;
  };
  intermediaryId: string;
  authorizationLink: string;
  linkExpirationDate: string;
  status: AuthorizationStatusEnum;
  createdAt: string;
  updatedAt: string;
  type?: PartnerType;
};

export type GetAuthorizationResponse = {
  pagination: {
    skip: number;
    limit: number;
    sort: string;
    order: string;
    total: number;
  };
  preTransactions: PreTransaction[];
};

export const getAuthorization = async (params?: GetAuthorizationParams) => {
  const queryParams = {
    ...params,
    sellerIds: params?.sellerIds?.join(","),
    customerIds: params?.customerIds?.join(","),
    status: params?.status?.join(","),
    type: params?.type?.join(","),
  };

  const { data } = await httpClient
    .get<GetAuthorizationResponse>("/pre-transaction", {
      params: queryParams,
    })
    .catch((error) => {
      throw error?.response?.data || error;
    });

  return data;
};
